import { StringFilter } from "./string-filter";

export class PermissionFilter {
    public id?: StringFilter;
    public name?: StringFilter;
}
